module.exports = __webpack_public_path__ + "img/risk-control.48e427f2.png";